import { Checkbox, Table } from '@mairistem/composants';
import _ from 'lodash';

import type { FactureType } from '@/types';

import FactureRecuTableOptions from '../../FactureRecuTableOptions';

interface ModalEncaissementTableHeaderProps {
  factures: FactureType[];
  selected: number[];
  produitsMontants: boolean;
  toggleProduitsMontants: () => void;
  onSelect: (checked: boolean) => void;
}

const ModalEncaissementTableHeader = (props: ModalEncaissementTableHeaderProps) => {
  const { factures, selected, produitsMontants, toggleProduitsMontants, onSelect } = props;

  return (
    <Table.Header
      style={{
        position: 'sticky',
        top: -1,
        background: 'white',
        zIndex: 10,
      }}
    >
      <Table.Row>
        {_.size(factures) > 1 && (
          <Table.HeaderCell style={{ width: 40 }} textAlign="center">
            <Checkbox
              data-testid="checkbox-select-all"
              checked={_.isEqual(_.size(factures), _.size(selected))}
              onChange={(e, data) => onSelect(data.checked)}
            />
          </Table.HeaderCell>
        )}
        <Table.HeaderCell style={{ width: 200 }}>N° de facture</Table.HeaderCell>
        <Table.HeaderCell>Payeur</Table.HeaderCell>
        <Table.HeaderCell>Cycle de facturation</Table.HeaderCell>
        <Table.HeaderCell style={{ width: 100 }} textAlign="center">
          Date limite
        </Table.HeaderCell>
        {produitsMontants && (
          <Table.HeaderCell textAlign="center">Produits et montants</Table.HeaderCell>
        )}
        <Table.HeaderCell style={{ width: 175 }} textAlign="right">
          Montant facture
        </Table.HeaderCell>
        <Table.HeaderCell style={{ width: 175 }} textAlign="right">
          Montant à encaisser
        </Table.HeaderCell>
        <FactureRecuTableOptions
          onProduitMontantsClick={toggleProduitsMontants}
          produitsMontantsVisible={produitsMontants}
        />
      </Table.Row>
    </Table.Header>
  );
};

export default ModalEncaissementTableHeader;
